import styled from 'styled-components';

import type { FlyingElementSrc } from '../../types';

interface ScWheelTemplateProps {
  backgroundImage: string;
}

interface ScFlyingElementProps extends FlyingElementSrc {
  delay: number;
}

export const ScFlyingElement = styled.img<ScFlyingElementProps>`
  position: absolute;
  top: ${({ posY }) => posY}%;
  left: ${({ posX }) => posX}%;
  transform: translate(-50%, -50%);
  z-index: 5;

  animation: move infinite ${({ delay }) => delay}s;

  @media (max-width: 660px) {
    top: ${({ posYMob }) => posYMob}%;
    left: ${({ posXMob }) => posXMob}%;
    zoom: 0.7;
  }

  @keyframes move {
    0% {
      transform: translateY(0) rotateY(0);
    }

    50% {
      transform: translateY(15px) rotateY(24deg);
    }

    100% {
      transform: translateY(0) rotateY(0);
    }
  }
`;

export const ScWheelTemplate = styled.div<ScWheelTemplateProps>`
  background: url(${({ backgroundImage }) => backgroundImage}) center / cover
    no-repeat;
  position: relative;
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  & .main__image {
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: space-between;

    & img {
      position: relative;
      width: 464px;
      height: 634px;
      max-width: 500px;

      &.main__img-mobile {
        display: none;
      }
    }

    &.right img {
      right: 0px;
    }
  }

  & .main__hero {
    padding: 24px 1rem 8px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    z-index: 200;
    width: 100%;

    & h1 {
      margin-top: 2rem;
      text-transform: uppercase;
    }
  }

  @media (max-width: 660px) {
    flex-direction: column;
    justify-content: space-between;

    & .main__hero {
      & h1 {
        font-size: 20px;
        margin-top: 24px;
        max-width: 260px;
      }
    }

    & .main__image {
      position: relative;
      margin-top: -70px;

      & img {
        display: none;

        &.main__img-mobile {
          display: block;
          width: 100%;
          height: auto;
          max-width: none;
        }
      }
    }
  }
`;
